module.exports = __webpack_public_path__ + "static/media/livingthedreamPoster.77e478ea.jpg";